import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=cd608430&scoped=true"
import script from "./PublicFooter.vue?vue&type=script&lang=js"
export * from "./PublicFooter.vue?vue&type=script&lang=js"
import style0 from "./PublicFooter.vue?vue&type=style&index=0&id=cd608430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd608430",
  null
  
)

export default component.exports